const { serverRequest } = Mobi2Go.app;

export class Logger {
    info(channel, message, context = {}) {
        this.log('info', channel, message, context);
    }

    error(channel, message, context = {}) {
        if (context.error) {
            context.error = this.parseError(context.error);
        }
        this.log('error', channel, message, context);
    }

    critical(channel, message, context = {}) {
        if (context.error) {
            context.error = this.parseError(context.error);
        }
        this.log('critical', channel, message, context);
    }

   log(level, channel, message, context) {
       if (typeof context !== 'object') {
           console.warn("Logger context must be of type object. Was ", context);
           context = {};
       }
        serverRequest({
            api_version: 1,
            endpoint: ['storefronts', 'log', level],
            type: 'POST',
            data: {
                channel,
                message,
                context
            },
            error(e) {
                // if our logger fails to log, wellll

                // mark error as handled to prevent UI from triggering generic error.
                return true;
            }
        });
    }

    parseError(error) {
        return error.responseJSON && error.responseJSON.error
                ? error.responseJSON.error
                : error.message
                    ? error.message
                    : error.toString();
    }
}
